import { PropsWithChildren } from 'react';
import Box from '@mui/material/Box';
import SvgIcon from '@mui/material/SvgIcon';
import { FlexContainer } from '../../ContentContainers/FlexContainer';
import { POLYGON_SVG_PATHS } from './polygonSvgPaths';
import { useTheme } from '@mui/material/styles';

interface PolygonalCardProps extends PropsWithChildren {
  polygonName: keyof typeof POLYGON_SVG_PATHS;
  height?: string;
}

export const PolygonalCard = ({
  children,
  polygonName = 'tetrahedron_diamond',
  height = '200px',
}: PolygonalCardProps) => {
  const theme = useTheme();
  const viewBox = '0 0 200 200';

  return (
    <Box
      sx={{
        position: 'relative',
        width: height,
        height,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {/* 1. SVG renders the shape, filling the container */}
      <SvgIcon
        viewBox={viewBox}
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }}
      >
        <path
          d={POLYGON_SVG_PATHS[polygonName]}
          fill="#ffffff"
          stroke={theme.palette.divider}
          strokeWidth={1}
        />
      </SvgIcon>

      {/* 2. Content Box for Children */}
      <FlexContainer
        direction="column"
        sx={{
          position: 'relative',
          height: 'fit-content',
          maxWidth: '80%',
          textAlign: 'center',
          p: 2,
          color: theme.palette.text.primary,
          zIndex: 1,
        }}
      >
        {children}
      </FlexContainer>
    </Box>
  );
};
